import React from "react";
import TabSlider from "../../common/TabSlider";
import { CasinoSlotData } from "../../helper/Helper";
import { CasinoIcon } from "../../helper/Icon2";
import SwiperSlider from "../../common/SwiperSlider";

function CasinoTabContent() {
  return (
    <>
      <SwiperSlider
        sectionHeading={"Casino"}
        icon={<CasinoIcon />}
        data={CasinoSlotData}
      />
    </>
  );
}

export default CasinoTabContent;
